import { render, staticRenderFns } from "./WeekMarks.vue?vue&type=template&id=7c18dc23&scoped=true"
import script from "./WeekMarks.vue?vue&type=script&lang=js"
export * from "./WeekMarks.vue?vue&type=script&lang=js"
import style0 from "./WeekMarks.vue?vue&type=style&index=0&id=7c18dc23&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c18dc23",
  null
  
)

export default component.exports